
import { cls } from 'tagged-classnames-free';
interface ILyriceActionBtnProps {
  icon: React.ReactNode
  text: string
  onClick: () => void
  disabled?: boolean
}

const LyriceActionBtn = (props: ILyriceActionBtnProps) => {
  const { icon = '', text = '', onClick, disabled = false } = props

  const handleClick = () => {
    if (disabled) return
    onClick()
  }

  return (
    <div
      className={cls`
        text-f-text-tertiary
        flex
        cursor-pointer
        items-center
        gap-1
        text-sm
        ${disabled && 'opacity-40'}
      `}
      onClick={handleClick}
    >
      <span className={cls`${icon} size-4`}></span>
      <span>{text}</span>
    </div>
  )
}

export default LyriceActionBtn
